
const FOOTER_TEMPLATE = `
	<nav class="footer-nav">
		<ul class="pull-right">
			<li><a href="index.html#<%= app.getLanguage() %>/credits"><%= app.localeManager.get("footer.credits") %></a></li>
			<li><a href="https://literacy.concordia.ca/resources/acknowledgements/en/reads.php#tab-funders"><%= app.localeManager.get("footer.funders") %></a></li>
			<li><a href="https://literacy.concordia.ca/resources/acknowledgements/en/reads.php#tab-team"><%= app.localeManager.get("footer.team") %></a></li>
		</ul>
	</nav>`
;

const Footer = Backbone.View.extend({

	tagName: "footer",
	
	template: _.template(FOOTER_TEMPLATE),

	render() {
		this.$el.html(this.template());

		return this;
	}
});